import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Container, Input, Button } from 'reactstrap'
import sanitizeHtml from 'sanitize-html'
import { Spinner } from 'reactstrap'

import backendAPI from '../../services/backend'
import AlertModal from '../Modals/alertModal/AlertModal'
import WaitingModal from '../Modals/waitingModal/WaitingModal'
import constants from '../../constants'
import './PrivacyDisclaimer.css'

const PrivacyDisclaimer = (props) => {
    const [error, setError] = useState()
    const [isWaitingModalOpen, setIsWaitingModalOpen] = useState(true)
    const history = useHistory()
    const location = useLocation()

    const [agreeCheck, setAgreeCheck] = useState(false)
    const [consentResponse, setConsentResponse] = useState([])
    const [loginResponse, setLoginResponse] = useState([])
    const [sendingLogin, setSendingLogin] = useState(false)
    const [tempToken, setTempToken] = useState(location.state ? location.state.token : '')

    const fetchDisclaimerContent = async () => {
        try {
            const disclaimerResponse = await backendAPI.getDisclaimerContent(tempToken);
            console.log(`PrivacyDisclaimer ${JSON.stringify(disclaimerResponse)}`);
            setConsentResponse(disclaimerResponse.consentSettings);
            sessionStorage.setItem(constants.SESSION_KEY_DISCLAIMER_RESPONSE, JSON.stringify(disclaimerResponse.consentSettings))
        } catch (error) {
            setError(`An error occured while fetching data:${JSON.stringify(error.message)}`)
            console.log(error)
        } finally {
            setIsWaitingModalOpen(false)
        }

    }

    const notifyUserLogin = async () => {
        try {
            setSendingLogin(true)
            console.log("Calling notify user login")
            sessionStorage.setItem(constants.GC_TOKEN, tempToken);
            const notifyLoginResponse = await backendAPI.postUserLogin(tempToken);
            sessionStorage.setItem(constants.SESSION_KEY_USER_LOGIN_RESPONSE, JSON.stringify(notifyLoginResponse))
            sessionStorage.setItem(constants.SESSION_KEY_CONSENTAGREED, true);
            console.log(`notifyUserLogin ::: Notify user login response ${JSON.stringify(notifyLoginResponse)}`);
            setLoginResponse(notifyLoginResponse)
            
            console.log('Navigating to Conversation Page')
            history.push("/conversations");
            
            //history.push("/management/users/");
            

        } catch (error) {
            setError(`An error occured while fetching data:${JSON.stringify(error.message)}`)
            console.log(error)
        } finally {
            setSendingLogin(false)
        }

    }

    useEffect(() => {
        //console.log('location.state.token',location.state.token)
        fetchDisclaimerContent();
        notifyUserLogin();
    }, [])


    return (
        <div id="component-wrap">
            <WaitingModal
                isOpen={isWaitingModalOpen}
                header='Loading Privacy Disclaimer'
            />
            <AlertModal
                isOpen={!!error}
                header='Error'
                toggle={() => { setError(undefined) }}
                body={error}
            />
            <div id="center-container">
                    <div className="center-content">
                        <h4 className="content">{consentResponse.header ? consentResponse.header : "Recording As A Service"}</h4>
                        <br />
                        <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(consentResponse.body ? consentResponse.body : "") }} />
                        <br />
                        {(isWaitingModalOpen || error) ? null : (<p className="content"><Input addon type="checkbox" onChange={e => { setAgreeCheck(e.target.checked); console.log(agreeCheck) }} />&nbsp; {consentResponse.footer ? consentResponse.footer : "I agree"}</p>)}
                        <div className="continue-button">
                            <br />
                            {(isWaitingModalOpen || error) ? null : (<Button color="primary" disabled={!agreeCheck}
                                onClick={() => { notifyUserLogin() }
                                }> Continue {sendingLogin ? <Spinner size="sm" /> : null}</Button>)}
                        </div>
                    </div>
            </div>
        </div>
    )
}

export default PrivacyDisclaimer